export default "__VITE_ASSET__Ca1vEmuX__"